import { Button, Col, Row } from 'react-bootstrap';
import { AnimatedIconButton } from 'components/MiCuenta/AnimatedIconButton/AnimatedIconButton';
import "./ViewButton.style.css";

export default function ViewButton({
                        label,
                        onClick,
                        icon,
                        Size,
                        IconSize,
                        ToolTipMessage,
                        IsWhite = false,
                        disabled = false,
                    }) {
    return (
        <>
            <Row className="text-center">
                <Col sm={12} className="p-0">
                    {ToolTipMessage ? (
                        <AnimatedIconButton
                            message={ToolTipMessage}
                            size={Size}
                            height={IconSize}
                            width={IconSize}
                            iconName={icon}
                            onClick={onClick}
                            disabled={disabled}
                        />
                    ) : (
                        <AnimatedIconButton
                            size={Size}
                            height={IconSize}
                            width={IconSize}
                            iconName={icon}
                            onClick={onClick}
                            disabled={disabled}
                        />
                    )}
                </Col>
                {label && (
                    <Col sm={12} className="p-0 mt-2">
                        <h1
                            className="text-center"
                            style={{ fontSize: "1.5vh", margin: "auto", fontWeight: "bold" }}
                        >
                            {label}
                        </h1>
                    </Col>
                )}
            </Row>
        </>
    );
}